import React from 'react'
import PropTypes from 'prop-types'

import OverviewPage from './OverviewPage'
import ListApplications from './ListApplicationsPage'
import ApplicationsDetails from './ApplicationDetailsPage'

const PAGES = {
  overview: OverviewPage,
  application: ApplicationsDetails,
  applications: ListApplications,
}

export default class IntegrationsContainer extends React.PureComponent {
  static propTypes = {
    subsection: PropTypes.string,
  }

  static defaultProps = {
    subsection: 'overview',
  }

  render() {
    const Page = PAGES[this.props.subsection] || OverviewPage

    return <Page />
  }
}
